import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const useScrollWrapStyles = makeStyles({
  root: ({ theme, max }) => ({
    marginBottom: theme.spacing(5),
    [`@media(max-width: ${max}px)`]: {
      overflowX: 'auto',
      overflowY: 'hidden',
      marginRight: theme.spacing(-2),
      marginLeft: theme.spacing(-2),
      paddingLeft: theme.spacing(2),
    },
  }),
})

export const ScrollWrap = (props) => {
  const { children } = props
  const theme = useTheme()
  const classes = useScrollWrapStyles({ ...props, theme })
  return (
    <Box className={`${classes.root}`}>
      {children}
    </Box>
  )
}

ScrollWrap.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}
